var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18924 4.08211C4.1754 4.50047 4.2441 4.91746 4.39141 5.30927C4.53872 5.70108 4.76177 6.06004 5.04781 6.36565C5.33384 6.67126 5.67728 6.91754 6.05849 7.09042C6.43971 7.26331 6.85125 7.35942 7.26961 7.37326C7.68797 7.3871 8.10496 7.3184 8.49677 7.17109C8.88858 7.02378 9.24754 6.80073 9.55315 6.51469C9.85876 6.22866 10.105 5.88522 10.2779 5.50401C10.4508 5.12279 10.5469 4.71125 10.5608 4.29289C10.5746 3.87453 10.5059 3.45754 10.3586 3.06573C10.2113 2.67392 9.98823 2.31496 9.70219 2.00935C9.41616 1.70374 9.07272 1.45746 8.69151 1.28458C8.31029 1.11169 7.89875 1.01558 7.48039 1.00174C7.06203 0.987903 6.64504 1.0566 6.25323 1.20391C5.86142 1.35122 5.50246 1.57427 5.19685 1.86031C4.89124 2.14634 4.64496 2.48978 4.47208 2.87099C4.29919 3.25221 4.20308 3.66375 4.18924 4.08211Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15.875C13.2277 14.617 12.3433 13.5418 11.2086 12.7853C10.0738 12.0288 8.73974 11.625 7.375 11.625C6.01026 11.625 4.67617 12.0288 3.54143 12.7853C2.40669 13.5418 1.52226 14.617 1 15.875",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8a31f2489220b603995d1aac338f966c.svg";
export { ForwardRef as ReactComponent };